import { render, staticRenderFns } from "./cardifao-premium.vue?vue&type=template&id=9d1869ec&scoped=true"
import script from "./cardifao-premium.vue?vue&type=script&lang=ts"
export * from "./cardifao-premium.vue?vue&type=script&lang=ts"
import style0 from "./cardifao-premium.vue?vue&type=style&index=0&id=9d1869ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1869ec",
  null
  
)

export default component.exports